<template>
  <footer>
    <p v-html="config.COPYRIGHT" ></p>
  </footer>
</template>

<script>
    import siteConfiguration from '@/config';

    export default {
        name: 'app-footer',
        data(){
          return{
            config : siteConfiguration
          }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/AppFooter.vue